<template>
  <div class="myorder">
    <van-nav-bar :title="title" fixed border>
      <template #left>
        <img src="../../assets/img/icon/left-arrow.png" class="icon" @click="goBack()" />
      </template>
    </van-nav-bar>
    <div class="collapse">
		<van-pull-refresh v-model="refreshing" @refresh="onRefresh">
			<van-sticky :offset-top="40">
			<form action="#">
				<van-search
				  v-model.trim="filterParams.no"
				  show-action
				  placeholder="请输入订单号"
				  @focus="searchFocus=true"
				  @blur="searchFocus=false"
				  @search="onRefresh"
				>
					<template #action>
						<div @click="onRefresh">搜索</div>
					</template>
				</van-search>
			</form>
			</van-sticky>

			<van-list
			v-model="loading"
			:finished="finished"
			:finished-text="items.length==0?'暂无订单':'没有更多订单了'"
			@load="loadData"
			>
				<div class="col-item" v-for="(item, index) in items" :key="index">
					<div class="msg">
						<div class="topic">
							<van-icon name="label-o" class="color_red" size="18px"/>
							<span class="title">{{item.o_no}}</span>
						</div>
						<span class="time skin_color fw600">{{orderStatusObj[item.o_status]}}</span>
					</div>
					<van-cell-group>
						<div class="content dis_flex">
							<van-cell
								title="金额："
								:style="{width:'50%'}"
								:value="item.o_info?item.o_info.split(',')[0]:0">
								<template #right-icon>
									&nbsp;元
								</template>
							</van-cell>
							<van-cell
								title="运费："
								:style="{width:'50%'}"
								:value="item.o_info?item.o_info.split(',')[1]:0">
								<template #right-icon>
									&nbsp;元
								</template>
							</van-cell>	
							<span></span>
						</div>
						<div class="content dis_flex">
							<van-cell
								title="商家："
								:style="{width:'50%'}"
								:value="item.o_info?item.o_info.split(',')[2]:0">
								<template #right-icon>
									&nbsp;家
								</template>
							</van-cell>	
							<van-cell
								title="商品："
								:style="{width:'50%'}"
								:value="item.o_goods">
								<template #right-icon>
									&nbsp;件
								</template>
							</van-cell>	
							<span></span>
						</div>
						<div class="content dis_flex">	
							<van-cell
								title="已优惠："
								:value="item.o_info?item.o_info.split(',')[3]:0">
								<template #right-icon>
									&nbsp;元
								</template>
							</van-cell>	
						</div>		
					</van-cell-group>
					<div class="content label">
						{{item.create_time*1000|moment_format('Y-MM-DD HH:mm')}}
						<van-button type="danger" @click.stop="delShoppingOrder(item.o_id)" size="mini" v-if="item.cur_time-item.create_time>24*3600">删除</van-button>
						<van-button type="primary" @click.stop="toShoppingDetail(item)" size="mini">购物单</van-button>
						<van-button type="primary" @click.stop="toSelShoppingPay(item)" size="mini" class="btn-count-down" v-if="(item.cur_time-item.create_time<1800)&&(item.o_status==0||item.o_status==2)">付款<van-count-down class="fw600" format="mm:ss" :time="(1800-(item.cur_time-item.create_time))*1000" @finish="finishOrderCount(index)"/></van-button>
					</div>
				</div>
			</van-list>
		</van-pull-refresh>
    </div>

    <van-popup v-model="showPayTypes" position="bottom" :style="{ 'max-height': '80%' }">
		<van-cell-group title="选择收款方式" class="pay_type_group">
			<van-radio-group v-model="payBy">
				<van-radio :name="p.values" v-for="(p,i) in payTypes" :key="i">
				{{p.describe}}
				<template #icon="props">
					<img class="pay_icon" :src="props.checked ? require('../../assets/img/icon/pay/'+p.values+'_active.png') : require('../../assets/img/icon/pay/'+p.values+'.png')" />
				</template>
				</van-radio>
			</van-radio-group>
			<van-button type="primary" block @click="toShoppingPay(1)" >马上付款</van-button>
			<van-button type="info" block @click="toShoppingPay(2)" >生成付款码</van-button>
		</van-cell-group>
    </van-popup>

    <van-popup v-model="showPayQRCode" position="bottom" :style="{ 'max-height': '80%' ,'text-align':'center'}">
		<van-cell-group title="扫描二维码付款" class="pay_type_group">
			<div>金额：{{payQRCode.amount}}元</div>
			<vue-qr :text="payQRCode.url" :size="220" ref="Qrcode"></vue-qr>
			<div>订单号：{{payQRCode.o_no}}</div>
			<van-button type="danger" block @click="onRefresh(true)" >完成付款</van-button>
		</van-cell-group>
    </van-popup>

	<van-popup v-model="showShoppingInfo" position="bottom" :style="{ 'max-height': '80%' }">
		<van-cell-group>
			<van-cell
				title="订单编号："
				 label-width="100px"
				:value="shoppingInfo.o_no"
				>
			</van-cell>
			<van-cell
				title="收货地址："
				 label-width="100px"
				:value="shoppingInfo.o_address?shoppingInfo.o_address:'无'"
				v-if="shoppingInfo.o_address"
				>
			</van-cell>
			<van-cell
				title="联系信息："
				 label-width="100px"
				:value="shoppingInfo.o_picker?(shoppingInfo.o_picker+' , '+shoppingInfo.o_telphone):'无'"
				v-if="shoppingInfo.o_picker"
				>
			</van-cell>
		</van-cell-group>
		<div v-if="shoppingDetail.length>0">
			<div class="col-item" v-for="(s, i) in shoppingDetail" :key="'d_'+i">
				<div class="msg">
					<div class="topic">
						<img :src="attach_url+s.s_img" alt />
						<span class="title">{{s.s_name}}</span>
					</div>
				</div>
				<div class="content">
					<van-card
					  :price="item.g_amount"
					  :num="item.g_num"
					  :title="item.g_name?item.g_name:'产品已下架'"
					  :thumb="attach_url+item.g_img"
					  class="van-card-small"
					  v-for="(item,index) in s.goods"
					  :key="index"
					  
					>
						<template #footer v-if="item.g_sku">
							已选：{{item.g_sku}}
						</template>
					</van-card>
				</div>
			</div>
		</div>
    </van-popup>

  </div>
</template>

<script type="text/ecmascript-6">
import { chkImgType } from "@/utils/common.js";
import { List, Card, Sticky, Search, Stepper ,Calendar, RadioGroup, Radio,CountDown } from "vant";
import vueQr from "vue-qr";

export default {
	name: "storeOrder",
	components: {
		"van-list": List,
		"van-card": Card,
		"van-sticky":Sticky,
		"van-search":Search,
		"van-stepper":Stepper,
		"van-calendar":Calendar,
		"van-radio-group":RadioGroup,
		"van-radio":Radio,
		"van-count-down":CountDown,
		"vue-qr":vueQr
	},
	data() {
		return {
			title: "我的订单",
			attach_url:this.Conf.serverPre,
			items: [],
			goodUnits:[],
			goodUnitObj:{},
			u_id: localStorage.getItem("u_id"),
			token: localStorage.getItem(localStorage.getItem("u_id") + "token"),
			filterParams:{
				u_id: localStorage.getItem("u_id"),
				token: localStorage.getItem(localStorage.getItem("u_id") + "token"),
				status:-1,
				no:''
			},
			cur_s_id:-1,
			page:0,
			pageSize:0,
			total:0,
			loading: false,
			finished: false,
			refreshing: false,
			orderStatusObj:{'0':'待支付','1':'已支付','2':'部分支付','99':'已完成','-1':'已取消'},
			searchFocus:false,

			payTypes:[],
			showPayTypes:false,
			payBy:'',
			showPayQRCode:false,
			payQRCode:{},
			newWindonObj:null,

			showShoppingInfo:false,
			shoppingInfo:{},

			shoppingDetail:[]
		};
	},
	mounted() {
		// 获取浏览器可视区域高度
		this.winH = `${document.documentElement.clientHeight}`;
		window.onresize = function temp() {
			this.winH = `${document.documentElement.clientHeight}`;
		};
	},
	created() {
		this.getStateConfigs();
		this.loadData();
		this.getPayTypes();
	},
	methods: {
		getStateConfigs(){
			const confs = this.$store.state.common.configs;
			if(confs){
				if(confs.attach_url){
					this.attach_url = confs.attach_url.values;
				}
			}else{
				setTimeout(() => {
					this.getStateConfigs();
				},1000);
			}
		},
		goBack() {
			this.$router.go(-1);
		},
		loadData() {
			if (this.finished) {
				return false;
			}
			this.loading = true;
			setTimeout(() => {
				if (this.refreshing) {
					this.items = [];
					this.refreshing = false;
				}
				this.page = this.page+1;
				var params = this.filterParams;
				params.page = this.page;

				var url = this.Conf.serverUrl + "User/myOrder" + "?num="+Math.random();
				this.$axios
				.post(url, this.$qs.stringify(params))
				.then(response => {
					this.loading = false;
					if(response.data.code == 40001){
						this.$toast.fail(response.data.msg);
					}else{
						if (response.data.page == 1) {
							this.pageSize = response.data.pageSize;
							this.total = response.data.total;
							this.items = response.data.orders;
						}else{
							this.items = this.items.concat(response.data.orders);
						}
						if(this.page*this.pageSize >= this.total){
							this.finished = true;
						}
					}
				})
				.catch(error => {});
			}, 1000);
		},
		onRefresh(cur) {
			this.showPayQRCode = false;
			this.finished = false;
			this.page = cur?(this.page-1):0;
			this.loadData();
		},
		getPayTypes(){
			var params = {
				group: 'sys_pay'
			};
			var url = this.Conf.serverUrl + "Dictionary/options" + "?num="+Math.random();
			this.$axios
			.post(url, this.$qs.stringify(params))
			.then(response => {
				this.payTypes = response.data.dicts;
			})
			.catch(error => {});
		},
		finishOrderCount(i){
			this.items[i].cur_time += 1800;
		},
		toShoppingDetail(item){
			this.shoppingInfo = item;
			this.showShoppingInfo = true;
			this.getShoppingDetail(item.o_no)
		},
		toSelShoppingPay(item){
			this.shoppingInfo = item;
			this.showPayTypes = true;
			this.payBy = "";
		},
		toShoppingPay(t){
			if(this.payBy == ""){
				this.$toast.fail('请选择付款方式！');
				return false;
			}
			let postData = {
				o_no:this.shoppingInfo.o_no,
				s_type:t
			};
			postData.u_id = this.u_id;
			postData.token = this.token;
			postData.pay_by = this.payBy;
			if(t == 1){
				this.newWindonObj = window.open('_blank');
			}
			let that = this;
			var url = this.Conf.serverUrl + "User/pay" + "?num="+Math.random();
			this.$axios
			.post(url, this.$qs.stringify(postData))
			.then(response => {
				if (response.data.msg) {
					that.$toast.success(response.data.msg);
				}
				if(response.data.code == 200){
					that.showPayTypes = false;
					that.payQRCode = response.data.data;
					if(that.payQRCode.s_type == 2){
						that.showPayQRCode = true;
					}else{
						if (window.plus) {
							plus.runtime.openURL(that.payQRCode.url);
						} else {
							that.newWindonObj.location=that.payQRCode.url; // 后更改页面地址
						}
					}
				}
			})
			.catch(error => {});
		},
		getShoppingDetail(no){
			var params = {
				u_id: this.u_id,
				token: this.token,
				o_no:no
			};
			var url = this.Conf.serverUrl + "User/orderDetail" + "?num="+Math.random();
			this.$axios
			.post(url, this.$qs.stringify(params))
			.then(response => {
				if(response.data.code == 200){
					this.shoppingDetail = response.data.data;
				}else if(response.data.msg){
					this.$toast.fail(response.data.msg);
					return false
				}
			})
			.catch(error => {});
			
		},
		delShoppingOrder(id){
			this.$dialog
			.confirm({
				title: "温馨提醒",
				message: "确定删除此订单吗？",
			})
			.then(() => {
				var params = {
					u_id: this.u_id,
					token: this.token,
					o_id:id
				};
				var url = this.Conf.serverUrl + "User/orderDel" + "?num="+Math.random();
				this.$axios
				.post(url, this.$qs.stringify(params))
				.then(response => {
					if(response.data.msg){
						this.$toast.success(response.data.msg);
					}
					if(response.data.code == 200){
						this.onRefresh(true);
					} 
				})
				.catch(error => {});
			})
			.catch((error) => {});
		}
	},
	filters:{
		sumOrderPrice(u){
			let total = 0;
			for(var i in u.goods){
				total += u.goods[i].g_price*u.goods[i].buys
			}
			return total*100;
		}
	},
	watch:{
	},
	beforeDestroy: function () {
	}
};
</script>




// WEBPACK FOOTER //
// src/components/My/Order.vue